import React, { useContext, useEffect } from 'react';
import { Watermark, APIAlert } from '@mummssoftware/common-ui';
import { BereavementContext } from '../../context';
import { Tables } from './Tables';
import { Container } from '../../components/layout/WrapperDiv';

export declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber?: string | undefined;
}>;

type BereavementProps = {
  smallWidget?: boolean;
  errorInfo?: mumms.ErrorInfo;
  clearError: () => void;
} & typeof RouteProps;

export const Bereavement = ({
  smallWidget,
  errorInfo,
  clearError,
}: BereavementProps) => {
  const { watermark, startLoadingTime, onWidgetReady } = useContext(
    BereavementContext,
  );

  useEffect(() => {
    const loadingDuration = (Date.now() - startLoadingTime) / 1000;
    // callback to alert dashboard the view is ready
    onWidgetReady && onWidgetReady('Bereavement' as mumms.ComponentName);
    console.log(
      '## CARE PLAN _ BEREAVEMENT WIDGET END ##',
      loadingDuration,
      's',
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container id="bereavement-container">
      <APIAlert errorInfo={errorInfo} handleClose={() => clearError()} />
      {watermark && watermark.show ? (
        <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
      ) : null}
      <Tables smallWidget={smallWidget} />
    </Container>
  );
};

export default Bereavement;
